import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import {
  FormSubGroup,
  FormSubGroupHeader,
  FormSubGroupHeading,
  FormSubGroupWrapper,
  ImageWrapper,
  Section,
  SectionColumn,
} from '../../components/layout'
import {
  NumberInput,
  SelectInput,
  TextAreaInput,
  TextInput,
  DateInput,
  TimeInput,
} from '../../components/layout/form/input'
import { DateTimeInputWrapper } from '../../components/layout/form/style/ComboInputWrapper'
import { Divider } from '../../containers/TowingOrderPage/EditTowingOrder/TowingOrderDetailsSubFormContents'
import { EditTowingOrder } from '../../containers/TowingOrderPage/EditTowingOrder/types'
import autoliitto from '../../images/autoliitto.png'
//import {persistentDelete, persistentGet} from '../../util/localStorage/localStorage'
import { formatMessageSafe } from '../../util/translateInputOptions'
import { Button } from '../Button'
import { ALTimeChangeModal } from './ALTimeChangeModal'
import { AlArcCodesForm } from '../AlArcCodesForm'
import { messages } from './messages'

interface ALOrderSubFormProps {
  serviceTypeOptions: object[]
  setFieldValue: (field: string, value: any) => void
  towingOrder: EditTowingOrder
  getOriginalValue: (field: string) => any
}

export const ALOrderSubForm: React.FC<ALOrderSubFormProps> = ({
  serviceTypeOptions,
  setFieldValue,
  towingOrder,
  getOriginalValue,
}) => {
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)
  const [showTimeModal, setShowTimeModal] = useState<boolean>(false)
  // const [timeFieldEnabled, setTimeFieldEnabled] = useState<boolean>(false)
  /* const editTowingTime = useCallback(
    (delayedTowing: boolean, ) => {
      //setTimeFieldEnabled(true)
      setShowTimeModal(false)
      persistentDelete('ALTimeChangeData')
      if (onEditTime) {
        onEditTime(delayedTowing)
      }
    },
    [onEditTime]
  ) */

  const closeTimeChangeModal = () => {
    setShowTimeModal(false)

    //persistentDelete('ALTimeChangeData')
  }
  return (
    <>
      {showTimeModal && (
        <ALTimeChangeModal
          label={formatMessage(messages.changeTime)}
          onClose={closeTimeChangeModal}
          isVisibleTimeInput={true}
          setFieldValue={setFieldValue}
          getOriginalFieldValue={getOriginalValue}
          useQueryOnly={false}
          towingOrder={towingOrder}
        />
      )}
      <ALFormSubGroupWrapper>
        <ALFormSubGroupHeader>
          <FormSubGroupHeading>
            <ImageWrapper>
              <img src={autoliitto} alt="AL" width={`95px`} />
            </ImageWrapper>
          </FormSubGroupHeading>
          <Button
            category="on"
            label={formatMessage(messages.changeTime)}
            onClick={() => setShowTimeModal(true)}
            size="s"
            maxWidth="10rem"
          />
        </ALFormSubGroupHeader>
        <FormSubGroup>
          <Section columns={2}>
            {getOriginalValue('jobDetails.towingDateType') === 'single' ? (
              <>
                <DateTimeInputWrapper>
                  <DateInput label={formatMessage(messages.date)} name="jobDetails.towingDate" disabled={true} />
                  &nbsp;
                  <TimeInput label={formatMessage(messages.time)} name="jobDetails.towingTime" disabled={true} />
                </DateTimeInputWrapper>
                <SectionColumn />
              </>
            ) : null}
            {getOriginalValue('jobDetails.towingDateType') === 'span' ? (
              <>
                <DateTimeInputWrapper>
                  <DateInput label={formatMessage(messages.dateFrom)} name="jobDetails.towingDate" disabled={true} />
                  &nbsp;
                  <Divider alignSelfEnd />
                  &nbsp;
                  <DateInput
                    label={formatMessage(messages.dateUntil)}
                    name="jobDetails.towingEndDate"
                    disabled={true}
                  />
                </DateTimeInputWrapper>
                <DateTimeInputWrapper>
                  <TimeInput label={formatMessage(messages.timeFrom)} name="jobDetails.towingTime" disabled={true} />
                  &nbsp;
                  <Divider alignSelfEnd />
                  &nbsp;
                  <TimeInput
                    label={formatMessage(messages.timeUntil)}
                    name="jobDetails.towingEndTime"
                    disabled={true}
                  />
                </DateTimeInputWrapper>
              </>
            ) : null}
            {/* <SectionColumn>
            <TimeInput label="Klo" name="jobDetails.towingTime" />
          </SectionColumn> */}
            <SectionColumn>
              <TextInput
                label={formatMessage(messages.caseNumber)}
                name="automobileAndTouringClubFinland.caseNumber"
                disabled
              />
            </SectionColumn>
            <SectionColumn>
              <TextInput
                label={formatMessage(messages.billingInfo)}
                name="automobileAndTouringClubFinland.billingInfo"
                disabled
              />
            </SectionColumn>
            <SectionColumn>
              <NumberInput
                label={formatMessage(messages.personCount)}
                name="automobileAndTouringClubFinland.personCount"
                decimals={0}
              />
            </SectionColumn>
            <SectionColumn>
              <TextInput
                label={formatMessage(messages.serviceChannel)}
                name="automobileAndTouringClubFinland.serviceChannel"
                disabled
              />
            </SectionColumn>

            {/* <SectionColumn>
            <NumberInput label="Mittarilukema, km" name="automobileAndTouringClubFinland.vehicleMileage" decimals={0} />
          </SectionColumn> */}

            {/*<SectionColumn>
            {serviceType === TowingRecordServiceType.TOWING && (
              <NumberInput label="Laskutettavat kilometrit" name="automobileAndTouringClubFinland.distanceTowed" />
            )}
          </SectionColumn>*/}
          </Section>
          <Section>
            <SectionColumn>
              <SelectInput
                label={formatMessage(messages.serviceType)}
                name="jobDetails.serviceType"
                options={serviceTypeOptions}
              />
            </SectionColumn>
            <AlArcCodesForm serviceType={towingOrder.jobDetails.serviceType} />
          </Section>
          <Section columns={2}>
            <SectionColumn>
              <TextAreaInput label={formatMessage(messages.additionalInfo)} name="jobDetails.additionalInfo" />
            </SectionColumn>
            <SectionColumn>
              <TextAreaInput label={formatMessage(messages.notes)} name="jobDetails.notes" />
            </SectionColumn>

            {/*<SectionColumn>
            <TextAreaInput
              label="Autoliiton tilannearvio"
              name="automobileAndTouringClubFinland.situationDescription"
              disabled
            />
          </SectionColumn>*/}
          </Section>
        </FormSubGroup>
      </ALFormSubGroupWrapper>
    </>
  )
}

export const ALFormSubGroupHeader = styled(FormSubGroupHeader as any)`
  background-color: ${props => props.theme.colors.autoliittoYellow};
`
export const ALFormSubGroupWrapper = styled(FormSubGroupWrapper as any)`
  border-color: ${props => props.theme.colors.autoliittoYellow} !important;
`
